import { blockCategories } from '../../categories';

export default function (editor, opts = {}) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    opts = {
        category: blockCategories.basic,
        label: 'Liste',
        block: {},
        props: {},
        style: {},
        ...opts
    };

    domComponents.addType('list-item', {
        model: {
            defaults: {
                tagName: 'li',
                draggable: ['list-container'],
                droppable: true,
                editable: false,
                attributes: { class: 'list-item' },
                traits: [],
                label: 'List Item',
                components: [
                    {
                        type: 'text',
                        content: 'List item',
                        editable: true,
                        droppable: false,
                        draggable: false
                    }
                ],
                style: {
                    'display': 'list-item',
                    'padding': '2px 0'
                }
            }
        }
    });

    domComponents.addType('list-container', {
        model: {
            defaults: {
                tagName: 'ul',
                draggable: true,
                droppable: ['list-item'],
                attributes: { class: 'list-container' },
                traits: [
                    {
                        type: 'select',
                        name: 'list-type',
                        label: 'List Type',
                        options: [
                            { value: 'ul', name: 'Unordered List (ul)' },
                            { value: 'ol', name: 'Ordered List (ol)' }
                        ],
                        changeProp: 1
                    },
                    {
                        type: 'select',
                        name: 'list-style-type',
                        label: 'List Style',
                        options: [
                            { value: 'disc', name: 'Disc (•)' },
                            { value: 'circle', name: 'Circle (○)' },
                            { value: 'square', name: 'Square (■)' },
                            { value: 'decimal', name: 'Decimal (1, 2, 3...)' },
                            { value: 'decimal-leading-zero', name: 'Decimal Leading Zero (01, 02, 03...)' },
                            { value: 'lower-roman', name: 'Lower Roman (i, ii, iii...)' },
                            { value: 'upper-roman', name: 'Upper Roman (I, II, III...)' },
                            { value: 'lower-alpha', name: 'Lower Alpha (a, b, c...)' },
                            { value: 'upper-alpha', name: 'Upper Alpha (A, B, C...)' },
                            { value: 'lower-latin', name: 'Lower Latin (a, b, c...)' },
                            { value: 'upper-latin', name: 'Upper Latin (A, B, C...)' },
                            { value: 'disclosure-closed', name: 'Disclosure Closed (▶)' },
                            { value: 'disclosure-open', name: 'Disclosure Open (▼)' },
                            { value: 'none', name: 'None (no marker)' }
                        ],
                        changeProp: 1
                    }
                ],
                components: [
                    {
                        type: 'list-item',
                        components: [
                            {
                                type: 'text',
                                content: 'First item',
                                editable: true,
                                droppable: false,
                                draggable: false
                            }
                        ]
                    },
                    {
                        type: 'list-item',
                        components: [
                            {
                                type: 'text',
                                content: 'Second item',
                                editable: true,
                                droppable: false,
                                draggable: false
                            }
                        ]
                    },
                    {
                        type: 'list-item',
                        components: [
                            {
                                type: 'text',
                                content: 'Third item',
                                editable: true,
                                droppable: false,
                                draggable: false
                            }
                        ]
                    }
                ],
                label: 'List',
                'list-type': 'ul',
                'list-style-type': 'disc',
                style: {
                    'list-style-type': 'disc',
                    'padding-left': '20px',
                    'margin': '12px 0'
                }
            },
            init() {
                this.on('change:list-type', this.updateListType);
                this.on('change:list-style-type', this.updateListStyle);
                this.updateListType();
            },
            updateListType() {
                const listType = this.get('list-type') || 'ul';
                this.set('tagName', listType);

                const currentStyleType = this.get('list-style-type');
                if (!currentStyleType || currentStyleType === 'disc' || currentStyleType === 'decimal') {
                    const defaultStyle = listType === 'ul' ? 'disc' : 'decimal';
                    this.set('list-style-type', defaultStyle);
                    this.addStyle({
                        'list-style-type': defaultStyle
                    });
                } else {
                    this.addStyle({
                        'list-style-type': currentStyleType
                    });
                }

                const view = this.getView();
                if (view) {
                    view.render();
                }
            },
            updateListStyle() {
                const styleType = this.get('list-style-type') || 'disc';
                this.addStyle({
                    'list-style-type': styleType
                });

                const view = this.getView();
                if (view) {
                    view.render();
                }
            }
        },
        view: {
            init() {
                this.listenTo(this.model, 'change:tagName', this.render);
                this.listenTo(this.model, 'change:style', this.render);
            }
        }
    });

    blockManager.add('list-block', {
        label: opts.label,
        category: opts.category,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
        </svg>`,
        content: {
            type: 'list-container'
        },
        ...opts.block
    });

    editor.Commands.add('list:add-item', {
        run(editor, sender, options) {
            const selected = editor.getSelected();
            if (selected && selected.get('type') === 'list-container') {
                const newItem = {
                    type: 'list-item',
                    components: [
                        {
                            type: 'text',
                            content: 'New item',
                            editable: true,
                            droppable: false,
                            draggable: false
                        }
                    ]
                };
                selected.append(newItem);
            }
        }
    });

    // Command to remove list item
    editor.Commands.add('list:remove-item', {
        run(editor, sender, options) {
            const selected = editor.getSelected();
            if (selected && selected.get('type') === 'list-item') {
                selected.remove();
            }
        }
    });

    editor.on('component:selected', (component) => {
        const toolbar = component.get('toolbar') || [];
        if (component.get('type') === 'list-container') {
            const hasAddButton = toolbar.some(
                (btn) => btn.command === 'list:add-item'
            );

            if (!hasAddButton) {
                component.set('toolbar', [
                    ...toolbar,
                    {
                        attributes: { class: 'fa fa-plus toolbar-icon', title: 'Add List Item' },
                        command: 'list:add-item',
                        label: ''
                    }
                ]);
            }
        }
    });
}
